import Mixpanel from '../modules/mixpanel';
require('slick-carousel');

const $body      = $(document.body);
const isTeamPage = $body.hasClass('page--team');

if (isTeamPage) {
  class Team {
    constructor() {
      this.mixpanel = new Mixpanel();
      this.mixpanel.bindTeamCTA();
    }
  }

  new Team();

  /**
   *
   * Carousel in team-english.html page CACOO-15538
   *
   */
  $('.js_team-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000
  });
}
